// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#sharedCharts .sharedChartAction i{cursor:pointer}", "",{"version":3,"sources":["webpack://./resources/js/components/MyFolder/SharedCharts.vue"],"names":[],"mappings":"AAIY,mCAAA,cAAA","sourcesContent":["\n#sharedCharts {\n    .sharedChartAction {\n        i {\n            @apply cursor-pointer;\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
